import * as yup from 'yup';

export const schemaTaxe = yup.object().shape({
  payment_method_id: yup.string().required('metodo de pagamento obrigatório'),
  description: yup.string().required('Descrição obrigatória'),
  type: yup.number().required('Tipo da taxa obrigatória'),
  initial_installment: yup.number().required('Parcela inicial obrigatória'),
  final_installment: yup.number().required('Parcela final obrigatória'),
  value: yup
    .number()
    .min(0, 'O valor deve ser maior ou igual a 0')
    .required('Valor obrigatório'),
});
